// @format
// @flow

import * as React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Core from './components/core'

function App() {
  return (
    <BrowserRouter>
      <Core />
    </BrowserRouter>
  )
}

export default App
